const exerciseWrapper: any = {
    display: "flex",
    padding: 15,
    borderRadius: 10,
    border: "1px solid rgb(175,198,219)",
    gap: 90,
    width: "98%",
    flexWrap: "nowrap",
    marginLeft: 20
}

const exerciseContainer: any = {
    // display: "flex",
    // gap: 10,
    marginBottom: 15,
    position: "relative"
}

const draggableIcon: any = {
    // display: "flex",
    // flexDirection: "column",
    // marginTop: 12
    position: "absolute",
    top: 15,
    left: -4
}

const crossIconStyle = {
    width: 24,
    margin: "0px 7px",
    cursor: "pointer",
    marginLeft: "auto"
};


export {
    exerciseWrapper,
    exerciseContainer,
    draggableIcon,
    crossIconStyle
}